import styled from 'styled-components';

// Inter's contextual alternates swap only the `*` next to digits for a
// centered glyph, so the mask renders at two heights; keep one glyph for all
export const MaskedCardNumber = styled.span`
  font-variant-ligatures: no-contextual;
`;
